import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { IconLikeFilled } from '@prisjakt/ui/icon/like-filled';
import { AppContext } from 'src/components/app-context';

import * as S from './styles';

const SentimentBadge = ({ badge, minPositive, showNrOfReviewsAs }) => {
  const { t } = useContext(AppContext);

  if (badge.nrOfPositiveReviews < minPositive) {
    return null;
  }

  const renderNumberOfReviews = () =>
    showNrOfReviewsAs === 'text'
      ? t('product', 'sentiment-badge.n-related-reviews', {
          n: badge.nrOfReviews,
        })
      : `(${badge.nrOfReviews})`;

  const textElement = (
    <S.Text>
      <span>
        {t('product', `sentiment-badge.${badge.name}-${badge.sentiment}`)}
      </span>
      <S.RelatedReviews>
        {showNrOfReviewsAs && renderNumberOfReviews()}
      </S.RelatedReviews>
    </S.Text>
  );

  return (
    <S.Badge>
      <IconLikeFilled size={16} color="positive500" />
      {textElement}
    </S.Badge>
  );
};

SentimentBadge.propTypes = {
  badge: PropTypes.shape({
    name: PropTypes.string,
    sentiment: PropTypes.oneOf(['positive', 'negative']),
  }),
  minPositive: PropTypes.number,
  showNrOfReviewsAs: PropTypes.oneOf(['number', 'text']),
};

SentimentBadge.defaultProps = {
  badge: null,
  minPositive: 2,
  showNrOfReviewsAs: undefined,
};

export default memo(SentimentBadge);
